import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { RedirectService } from 'src/app/services/redirect.service';
import { getFullPath } from '../lib/get-full-path';
import { AffiliateService } from '../services/affiliate.service';
import { AnalyticsService } from '../services/analytics.service';
import { BrowserService } from '../services/browser.service';
import { PromotionService } from '../services/promotion.service';
import { StorageService } from '../services/storage.service';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInRedirectGuard {
  constructor(
    private redirectService: RedirectService,
    private browserService: BrowserService,
    private analytics: AnalyticsService,
    private storage: StorageService,
    private toasts: ToastService,
    private promotionService: PromotionService,
    private affiliateService: AffiliateService,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    const loggedIn = this.browserService.getCookies()?.['picflow-loggedin'] === 'true';
    if (!loggedIn) return true;

    const path = getFullPath(next);

    if (!this.analytics.lastUrl && path.length === 0) {
      return this.redirectService.redirectTo(['a', 'galleries']);
    }

    if (['promo', 'pricing'].includes(path[0])) {
      return this.redirectService.redirectTo(['a', 'pricing']);
    }
    return true;
  }
}
